import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { registerModalBackHandler } from '../../lib/native';

/** Placeholder notifications popover — styled empty state until wired to data. */
export function NotificationsPopover({ anchorRef, onClose }: { anchorRef: React.RefObject<HTMLElement | null>; onClose: () => void }) {
  const [style, setStyle] = useState<React.CSSProperties | null>(null);

  useEffect(() => {
    if (!anchorRef.current) return;
    const rect = anchorRef.current.getBoundingClientRect();
    if (window.innerWidth < 768) {
      setStyle({ bottom: 16, left: 16, right: 16, width: 'auto' });
    } else {
      setStyle({ bottom: 96, left: rect.right + 12 });
    }
  }, [anchorRef]);

  // Android hardware back button closes this popover instead of navigating
  // the route underneath it.
  useEffect(() => registerModalBackHandler(onClose), [onClose]);

  if (!style) return null;

  return createPortal(
    <>
      <div className="fixed inset-0 z-[60]" onClick={onClose} />
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ ...style, background: 'var(--surface)', border: '1px solid var(--line)', borderRadius: 14, boxShadow: 'var(--shadow-hover)' }}
        className="fixed w-60 z-[61] flex flex-col items-center text-center gap-2 px-5 py-6"
      >
        <i className="ti ti-bell text-app-muted" style={{ fontSize: 'calc(20px * var(--text-scale))' }} />
        <p className="font-serif text-footnote text-app-fg">You're all caught up</p>
        <p className="text-caption text-app-muted leading-relaxed">Trip updates and messages will land here.</p>
      </div>
    </>,
    document.body,
  );
}

export default NotificationsPopover;
